import * as React from 'react';
import { observer } from 'mobx-react';
import style from './Button.module.scss';
import { JoinClassName } from '../../../utils/string';
import { t } from '../../../stores/TranslateStore';

export enum BUTTON_THEMES {
  BLUE,
  RED,
}

export interface ButtonActions {
  onClick?: () => any;
}

export interface ButtonProps extends ButtonActions {
  className?: any;
  style?: any;
  isMini?: boolean;
  isFull?: boolean;
  isIcon?: boolean;
  isMaterialTheme?: boolean;
  disabled?: boolean;
  theme?: BUTTON_THEMES,
  badge?: string;
  width?: number;
  height?: number;
  onMouseOver?: () => void;
  onMouseOut?: () => void;
  /**
   * children 을 현재 언어로 번역할지 여부. 기본값 true.
   *
   * t.T 는 children 이 문자열일 때만 번역하고 아이콘·JSX 는 그대로 통과시키므로
   * 아이콘 버튼이나 복합 children 은 안전하다. 다만 children 이 레코드 데이터가
   * 담긴 문자열(이름·코드 등)이면 translate={false} 로 꺼야 한다.
   */
  translate?: boolean;
}

// observer: 번역이 도착하면 t.dict 가 바뀌므로 다시 그려야 한다.
@observer
export class Button extends React.Component<ButtonProps> {
  render() {
    const widthApply = !this.props.width ? {} : {
      width: this.props.width,
    };

    const heightApply = !this.props.width ? {} : {
      height: this.props.height,
    };

    return (
      <div
        className={JoinClassName.make([
          style.container,
          this.props.className,
          this.props.isMini ? style.mini : false,
          this.props.isFull ? style.full : false,
          this.props.isIcon ? style.onlyIcon : false,
          this.props.theme === BUTTON_THEMES.RED ? style.red : false,
          this.props.isMaterialTheme ? style.material : false,
          this.props.disabled ? style.disabled : false,
        ])}
      >
        <button
          onClick={() => this.props.onClick && this.props.onClick()}
          onMouseOver={() => this.props.onMouseOver && this.props.onMouseOver()}
          onMouseOut={() => this.props.onMouseOut && this.props.onMouseOut()}
          style={{
            fontSize: 12,
            ...widthApply,
            ...heightApply,
            ...this.props.style,
          }}
        >
          {this.props.translate === false ? this.props.children : t.T(this.props.children)}
          {this.props.badge && this.props.badge !== '0' && <div className={style.badge}>{this.props.badge}</div>}
        </button>
      </div>
    );
  }
}
